import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from '@/view/home'
import index from '@/view/index'
import indexNoMenu from '@/view/indexNoMenu'
import indexNoheader from '@/view/indexNoheader'
import commodityCoupon from '@/view/commodityCoupon'
import commodityDiscount from '@/view/commodityDiscount'
import commodityPortfolio from '@/view/commodityPortfolio'
import productShow from '@/view/productShow'
import productShowByType from '@/view/productShowByType'
import productDetail from '@/view/productDetail'
import shoppingcart from '@/view/shoppingcart'
import confirmOrder from '@/view/confirmOrder'
import orderPaymentSucceeded from '@/view/orderPaymentSucceeded'
import inquiryManagement from '@/view/inquiryManagement'
import aboutUs from '@/view/aboutUs'
import blogManagement from '@/view/blogManagement'
import blogsearch from '@/view/blogSearchManagement'
import bolgDeatil from '@/view/bolgDeatil'
import forumManagement from '@/view/forumManagement'
import forumDetail from '@/view/forumDetail'
import personalCenter from '@/view/personalCenterManagement'
import personalCenter2 from '@/view/personalCenterManagement-2'
import newsPolicy from '@/view/newsPolicy'

import waitingPayment from '@/view/waitingPayment'
import searchProduct from '@/view/searchProduct'
import error from '@/view/error'


import login from '@/view/login'
import forgetPassword from '@/view/forgetPassword'
import emaiVerification from '@/view/emaiVerification'
import creatNewPassword from '@/view/creatNewPassword'

Vue.use(Router)


export default new Router({
  mode: 'history',
  base: '', // 路由前缀
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      children: [
        {
          path: '/',
          name: 'home',
          component: home
        },
        {
          path: '/commodityCoupon',
          name: '优惠券',
          component: commodityCoupon
        },
        {
          path: '/commodityDiscount',
          name: '折扣',
          component: commodityDiscount
        },
        {
          path: '/commodityPortfolio',
          name: '组合',
          component: commodityPortfolio
        },
        {
          path: '/productShow',
          name: '产品',
          component: productShow
        },
        {
          path: '/productShowByType',
          name: '产品',
          component: productShowByType
        },
        {
          path: '/productDetail',
          name: '产品详情',
          component: productDetail
        },
        {
          path: '/inquiryManagement',
          name: '询价',
          component: inquiryManagement
        },
        {
          path: '/aboutUs',
          name: '关于我们',
          component: aboutUs
        },
        {
          path: '/blogManagement',
          name: '博客',
          component: blogManagement
        },
        {
          path: '/blogsearch',
          name: '博客搜索',
          component: blogsearch
        },
        {
          path: '/bolgDeatil',
          name: '博客详情',
          component: bolgDeatil
        },
        {
          path: '/forumManagement',
          name: '论坛',
          component: forumManagement
        },
        {
          path: '/forumDetail',
          name: '论坛详情',
          component: forumDetail
        },
        {
          path: '/error',
          name: '出错',
          component: error
        },
        {
          path:'/searchProduct',
          name:'产品搜索',
          component: searchProduct
        }
      ]
    },
    {//
      path: '/indexNoheader',
      name: 'indexNoheader',
      component: indexNoheader,
      children: [
        {
          path: '/confirmOrder',
          name: '确认订单',
          component: confirmOrder
        },
        {
          path: '/orderPaymentSucceeded',
          name: '付款成功',
          component: orderPaymentSucceeded
        },
        
      ]
    },
    {
      path: '/indexNoMenu',
      name: 'indexNoMenu',
      component: indexNoMenu,
      children: [
        {
          path: '/shoppingcart',
          name: '购物车',
          component: shoppingcart
        },
        {
          path: '/personalCenter',
          name: '个人中心',
          component: personalCenter
        },
        {
          path: '/personalCenter2',
          name: '个人中心',
          component: personalCenter2
        },

        {
          path: '/waitingPayment',
          name: '等待付款',
          component: waitingPayment
        },
        // {
        //   path:'/searchProduct',
        //   name:'产品搜索',
        //   component: searchProduct
        // }
      ]
    },
    {
      path: '/login',
      name: '登录',
      component: login
    },
    {
      path: '/forgetPassword',
      name: '忘记密码',
      component: forgetPassword
    },
    {
      path: '/emaiVerification',
      name: '邮箱验证',
      component: emaiVerification
    },
    {
      path: '/creatNewPassword',
      name: '创建新密码',
      component: creatNewPassword
    },
    {
      path: '/newsPolicy',
      name: '政策',
      component: newsPolicy
    }

  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js